export default __webpack_public_path__ + "static/media/IMG-20241005-WA0044.872a1d0e.jpg";